// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.o0L8E8rAPIUeajToTDgq{background:var(--gray-a-15);border-radius:4px;justify-content:center;align-items:center;gap:8px;width:-webkit-fit-content;width:fit-content;padding:3.5px 8px;display:flex}.SqTUyUMiiIjX3dnRJ7io{background:var(--content-neutral-primary);width:1px;height:8px}.BwlD06LIIJ04iDjXuUfe{justify-content:space-between;align-items:center;margin:36px 0 40px;display:flex}.z6BzX8_sUrjeeluZPKWY{flex-direction:column;gap:8px;display:flex}.k7m7V10BiiEP6M4GgYsD,.okRaNQnwGQZ1DpDJgC9A{align-items:center;gap:4px;display:flex}.bZiZXJawOHjtGVva3o4j{border:1px solid var(--black-10);background:var(--green-10);border-radius:4px;margin-left:4px;padding:1px 4px 2px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"upgradeLabel": `o0L8E8rAPIUeajToTDgq`,
	"separator": `SqTUyUMiiIjX3dnRJ7io`,
	"header": `BwlD06LIIJ04iDjXuUfe`,
	"titleInfo": `z6BzX8_sUrjeeluZPKWY`,
	"description": `k7m7V10BiiEP6M4GgYsD`,
	"creditsTooltipContentTitle": `okRaNQnwGQZ1DpDJgC9A`,
	"annuallyTabInfo": `bZiZXJawOHjtGVva3o4j`
};
export default ___CSS_LOADER_EXPORT___;
